import {css} from '../utils.js';

const styles = css`
    .ddk-container .layout-footer-container {
        display: flex;
        align-items: center;
        background: ${props =>
            props.theme.footer_background_color ??
            'var(--ddk-surface-base-surface-4, #C1C1C1)'};
        font-family: ${props => props.theme.font_family};
    }

    .ddk-container .layout-footer-container .footer-content {
        height: 100%;
        width: 100%;
        display: flex;
        padding: var(--ddk-grid-6, 48px);
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
    }

    .ddk-container .footer-content .footer-leading {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
    }

    .ddk-container .footer-content .footer-title {
        color: ${props =>
            props.theme.footer_title_text ?? 'var(--ddk-text-base-primary)'};
        font-size: ${props =>
            props.theme.footer_title_font_size ?? 'var(--ddk-font-size-lg)'};
        font-family: Inter;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 36px */
        letter-spacing: 0.06px;
    }

    .ddk-container .footer-content .footer-tags {
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        gap: 16px var(--ddk-spacing-space-3, 24px);
        flex: 1 0 0;
        flex-wrap: wrap;
    }

    .ddk-container .footer-content .footer-trailing {
        display: flex;
        height: 100%;
        padding: var(--ddk-grid-1-half, 12px) 0px;
        justify-content: center;
        align-items: center;
    }

    .ddk-container .footer-content .footer-logo-container {
        display: flex;
        justify-content: center;
        min-width: 210px;
        max-width: 210px;
        max-height: 120px;
    }

    .ddk-container .footer-content .footer-logo-container img {
        max-width: 100%;
        max-height: 120px;
        height: auto;
    }

    @media screen and (max-width: 480px) {
        .ddk-container .footer-content .footer-logo-container {
            max-height: 100px;
            max-width: 100px;
        }

        .ddk-container .layout-footer-container .footer-content {
            flex-direction: column;
        }
    }
`;

export default styles;
